import api from "./api-service";

/**
 * Lista todos os erros de backup S3 com filtros (endpoint admin)
 */
export const findErrors = async (filters = {}) => {
  const params = {
    page: filters.page || 1,
    limit: filters.limit || 50,
    ...(filters.draftId && { draftId: filters.draftId }),
    ...(filters.errorType && { errorType: filters.errorType }),
    ...(filters.isNetworkError !== undefined && {
      isNetworkError: filters.isNetworkError,
    }),
    ...(filters.browser && { browser: filters.browser }),
    ...(filters.os && { os: filters.os }),
    ...(filters.startDate && { startDate: filters.startDate }),
    ...(filters.endDate && { endDate: filters.endDate }),
  };

  const response = await api().get("/therapy-draft/admin/errors", { params });
  return response.data;
};

/**
 * Busca erro específico por ID (endpoint admin)
 */
export const findErrorById = async (errorId) => {
  const response = await api().get(`/therapy-draft/admin/errors/${errorId}`);
  return response.data;
};

/**
 * Retorna estatísticas globais de erros (endpoint admin)
 */
export const getErrorStats = async (days = 7) => {
  const response = await api().get(
    "/therapy-draft/admin/errors/stats/summary",
    { params: { days } }
  );
  return response.data;
};

/**
 * Deleta erro específico (endpoint admin)
 */
export const deleteError = async (errorId) => {
  const response = await api().delete(
    `/therapy-draft/admin/errors/${errorId}`
  );
  return response.data;
};
